module.exports = __webpack_public_path__ + "static/media/ManageGroups-ImportTemplate.4d11adc1.xlsx";